const state = {
	activeAuction: {},
    auctions: [],
    auctionItems: {
		items: [],
		meta: {
			currentPage: 1,
			totalItems: null,
			totalPages: null
		},
		isFetching: false
	}
};

export default state;



// WEBPACK FOOTER //
// ./src/store/modules/auction/state.js